import React from 'react';
import { CreatedUserViewModel } from 'stageclip-common';

import styles from 'components/users/createUserForm.module.scss';

type ClientsUserPasswordModalBodyProps = {
  user: CreatedUserViewModel;
};

export const ClientsUserPasswordModalBody = (props: ClientsUserPasswordModalBodyProps) => {
  const {
    user: { email },
  } = props;

  return (
    <span className={styles.createdUserMessage}>
      We added the <span className={styles.email}>{email}</span>, he will receive an email in a moment
    </span>
  );
};
